export default {
  name: 'nama',
  save: 'simpan',
  tel: 'telefon',
  confirm: 'sahkan',
  cancel: 'batalkan',
  delete: 'batalkan',
  vanAddressEdit: {
    defaultAddress: 'Tetapkan sebagai alamat penghantaran lalai',
    telPlaceholder: 'Nombor telefon bimbit penerima',
    namePlaceholder: 'Nama Penerima'
  }
};



// WEBPACK FOOTER //
// src/locales/vant-ms_MY.js